<template>
  <div class="wrapper" :class="$i18n.locale">
    <div class="header">
      <div class="logo">
        <img class="header-logo" src="@/assets/img/logo.png" :alt="$t('topPage.altText.logo').toString()" />
      </div>
      <div>
        <router-link :to="{ name: 'signUp' }" class="sign-up-button">{{ $t("topPage.buttonText.signUp") }}</router-link>
        <router-link :to="{ name: 'signIn' }" class="login-button"> {{ $t("common.login") }} </router-link>
      </div>
    </div>
    <div class="containar-fluid">
      <div class="top-contents" :class="$i18n.locale">
        <p class="catchcopy-line" :class="$i18n.locale" v-html="$t('topPage.topMessage.catchcopyLine1')"></p>
        <p
          class="catchcopy-line catchcopy-line2"
          :class="$i18n.locale"
          v-html="$t('topPage.topMessage.catchcopyLine2')"
        ></p>
        <router-link :to="{ name: 'signUp' }" class="sign-up-button">{{ $t("topPage.buttonText.start") }}</router-link>
      </div>
      <div class="top-message">
        <p class="top-message-title" v-html="$t('topPage.topMessage.title')"></p>
        <p class="top-message-content" v-html="$t('topPage.topMessage.body')"></p>
        <p
          class="top-message-content top-message-description"
          :class="$i18n.locale"
          v-html="$t('topPage.topMessage.description')"
        ></p>
      </div>
      <div class="row row-gray">
        <div class="col-lg-9-l">
          <img
            class="service-img"
            src="@/assets/img/static/service-img.webp"
            :alt="$t('topPage.altText.catchCopy').toString()"
          />
        </div>
        <div class="col-lg-3-r">
          <div class="service-txt">
            <img class="main-logo" src="@/assets/img/logo.png" :alt="$t('topPage.altText.logo').toString()" />
            <p v-html="$t('topPage.service.description')"></p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3-l">
          <div class="screenshot-txt">
            <h2>{{ $t("topPage.features.plot.title") }}</h2>
            <h3>{{ $t("topPage.features.plot.subtitle") }}</h3>
            <p>{{ $t("topPage.features.plot.description") }}</p>
          </div>
        </div>
        <div class="col-lg-9-r">
          <img
            class="screenshot pc"
            src="@/assets/img/static/service-screen-plot.webp"
            :alt="$t('topPage.altText.catchCopy').toString()"
          />
          <img
            class="screenshot sp"
            src="@/assets/img/static/service-sp-screen-plot.webp"
            :alt="$t('topPage.altText.catchCopy').toString()"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3-l sp">
          <div class="screenshot-txt">
            <h2>{{ $t("topPage.features.character.title") }}</h2>
            <h3>{{ $t("topPage.features.character.subtitle") }}</h3>
            <p>{{ $t("topPage.features.character.description") }}</p>
          </div>
        </div>
        <div class="col-lg-9-l">
          <img
            class="screenshot pc"
            src="@/assets/img/static/service-screen-character.webp"
            :alt="$t('topPage.altText.catchCopy').toString()"
          />
          <img
            class="screenshot sp"
            src="@/assets/img/static/service-sp-screen-character.webp"
            :alt="$t('topPage.altText.catchCopy').toString()"
          />
        </div>
        <div class="col-lg-3-r pc">
          <div class="screenshot-txt">
            <h2>{{ $t("topPage.features.character.title") }}</h2>
            <h3>{{ $t("topPage.features.character.subtitleAlt") }}</h3>
            <p>{{ $t("topPage.features.character.description") }}</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3-l">
          <div class="screenshot-txt">
            <h2>{{ $t("topPage.features.editor.title") }}</h2>
            <h3>{{ $t("topPage.features.editor.subtitle") }}</h3>
            <p>{{ $t("topPage.features.editor.description") }}</p>
          </div>
        </div>
        <div class="col-lg-9-r">
          <img
            class="screenshot pc"
            src="@/assets/img/static/service-screen-editor.webp"
            :alt="$t('topPage.altText.catchCopy').toString()"
          />
          <img
            class="screenshot sp"
            src="@/assets/img/static/service-sp-screen-editor.webp"
            :alt="$t('topPage.altText.catchCopy').toString()"
          />
        </div>
      </div>
      <div class="vision-contents" :class="$i18n.locale">
        <p class="vision" :class="$i18n.locale" v-html="$t('topPage.vision.line1')"></p>
        <p class="vision vision-line2" :class="$i18n.locale" v-html="$t('topPage.vision.line2')"></p>
      </div>
      <div class="registration">
        <h2 v-html="$t('topPage.registration.title')"></h2>
        <p v-html="$t('topPage.registration.description')"></p>
        <router-link :to="{ name: 'signUp' }" class="sign-up-button">{{ $t("topPage.buttonText.signUp") }}</router-link>
        <router-link :to="{ name: 'signIn' }" class="login-button">{{ $t("common.login") }}</router-link>
      </div>
    </div>
    <site-footer :show-links="true" />
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import SiteFooter from "@/components/organisms/Footer.vue";

interface Data {
  previousTheme: string | null;
}

export default Vue.extend<Data, unknown, unknown, unknown>({
  components: {
    SiteFooter,
  },
  // NOTE: metaタグの設定
  metaInfo() {
    const meta = process.env.NODE_ENV !== "production" ? [{ name: "robots", content: "none" }] : [];
    return {
      title: this.$t("app.meta.title") as string,
      titleTemplate: "%s",
      meta: [
        ...meta,
        { vmid: "description", name: "description", content: this.$t("app.meta.description") as string },
        { vmid: "og:title", property: "og:title", content: this.$t("app.meta.title") as string },
        { vmid: "og:description", property: "og:description", content: this.$t("app.meta.description") as string },
        { vmid: "og:url", property: "og:url", content: window.location.href },
      ],
    };
  },
  data() {
    return {
      previousTheme: null,
    };
  },
  mounted() {
    // ライトモード固定: 現在のテーマを保存してからライトモードに強制
    this.previousTheme = document.documentElement.getAttribute("data-app-theme");
    document.documentElement.setAttribute("data-app-theme", "light");
  },
  destroyed() {
    // 元のテーマに戻す（nullの場合はデフォルトのlightを設定）
    document.documentElement.setAttribute("data-app-theme", this.previousTheme || "light");
  },
});
</script>

<style lang="scss" scoped>
/* パソコンで見たときは"pc"のclassがついた要素が表示される */
.pc,
.wrapper :deep(.pc) {
  display: block !important;
}
.sp,
.wrapper :deep(.sp) {
  display: none !important;
}
/* スマートフォンで見たときは"sp"のclassがついた要素が表示される */
@media only screen and (max-width: 750px) {
  .pc,
  .wrapper :deep(.pc) {
    display: none !important;
  }
  .sp,
  .wrapper :deep(.sp) {
    display: block !important;
  }
}
.wrapper {
  font-family: "ヒラギノ明朝 ProN", "Hiragino Mincho ProN", "ＭＳ 明朝", "MS Mincho", sans-serif;
}
/* 言語別フォント上書き（Noto Serif: Latin/CJK ベースライン統一設計） */
.wrapper.zh-CN {
  font-family: "Noto Serif SC", "Songti SC", "SimSun", serif;
}
.wrapper.zh-TW {
  font-family: "Noto Serif TC", "Songti TC", "PMingLiU", serif;
}
.wrapper.ko {
  font-family: "Noto Serif KR", "Batang", serif;
}
.wrapper.en {
  font-family: "Georgia", "Times New Roman", serif;
}
/* ヘッダー部分のレイアウト */
.header {
  width: 100%;
  background-color: rgba(243, 243, 242, 0.64);
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 1rem 3rem;
  z-index: 100;
}
.logo {
  width: 20%;
}
.header-logo {
  height: auto;
  width: 130px;
}
.sign-up-button {
  display: inline-block;
  vertical-align: middle;
  padding: 7.5px 25px;
  text-decoration: none;
  color: var(--color-text-on-fixed-bg);
  border-radius: var(--radius-rounded);
  background-color: var(--color-primary);
}
.login-button {
  display: inline-block;
  vertical-align: middle;
  margin-left: 15px;
  padding: 7.5px 25px;
  text-decoration: none;
  color: var(--color-text-normal);
  border-radius: var(--radius-rounded);
  background-color: var(--color-text-on-fixed-bg);
}

/*メインコンテンツの共通レイアウト*/
.containar-fluid {
  width: 100%;
  padding: 0px;
  color: var(--color-text-normal);
}
a {
  color: var(--color-text-normal);
  text-decoration: none;
  font-weight: var(--font-weight-bold);
}
/* TOPコンテンツのレイアウト */
.top-contents {
  height: 100vh;
  background-image: url("~@/assets/img/static/top-background.webp");
  background-size: cover;
  background-position: center;
  position: relative;
}
.catchcopy-line {
  float: right;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xxl);
  line-height: 36px;
  letter-spacing: 3px;
  background-color: rgba(255, 255, 255, 0.8);
  writing-mode: vertical-rl;
  padding: 0.8rem;
  margin: calc(8vh + 5%) 5% 0 0;
}
.catchcopy-line2 {
  margin-right: 4px;
}
/* TOPメッセージのレイアウト */
.top-message {
  width: 100%;
  padding: 70px 0;
  text-align: center;
}
.top-message-title {
  font-size: var(--font-size-xxl);
  font-weight: var(--font-weight-regular);
}
.top-message-content {
  font-size: var(--font-size-md);
  max-width: 720px;
  margin: 0 auto;
  line-height: 2rem;
}
.top-message-description {
  margin-top: 2rem;
}
.top-contents .sign-up-button {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 5%;
  font-size: var(--font-size-lg);
}
/* 画面説明のレイアウト */
.row {
  display: flex;
  width: 100%;
  padding: 50px 0px;
}
.row-gray {
  background-color: var(--color-surface-subtle);
}
.col-lg-9-l {
  display: inline-block;
  width: 70%;
  margin: 0px;
  padding: 50px 30px 50px 10%;
}
.col-lg-9-r {
  display: inline-block;
  width: 70%;
  margin: 0px;
  padding: 50px 10% 50px 30px;
}
.col-lg-3-r {
  display: inline-block;
  width: 30%;
  margin: 0px;
  padding: 50px 10% 50px 30px;
}
.col-lg-3-l {
  display: inline-block;
  width: 30%;
  margin: 0px;
  padding: 50px 30px 50px 10%;
}
.service-img {
  width: 100%;
}
.service-txt {
  padding-top: 25%;
}
.service-txt p {
  font-size: var(--font-size-md);
  line-height: 2rem;
}
.main-logo {
  display: block;
  width: 75%;
  padding: 15px;
}
.screenshot {
  width: 100%;
  border-radius: var(--radius-lg);
}
.screenshot-txt {
  padding-top: 25%;
}
.screenshot-txt h2 {
  font-size: var(--font-size-xxl);
  font-weight: var(--font-weight-regular);
}
.screenshot-txt h3 {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-regular);
}
.screenshot-txt p {
  font-size: var(--font-size-md);
  line-height: 2rem;
}
/* 2つ目のキャッチコピー画像のレイアウト */
.vision-contents {
  background-image: url("~@/assets/img/static/vision-background.webp");
  background-size: cover;
  height: 70vh;
  background-position: 0% 30%;
}
.vision {
  float: right;
  font-weight: var(--font-weight-regular);
  font-size: var(--font-size-xxl);
  line-height: 36px;
  letter-spacing: 3px;
  background-color: rgba(255, 255, 255, 0.8);
  writing-mode: vertical-rl;
  padding: 0.8rem;
  margin: 5% 5% 0 0;
}
.vision-line2 {
  margin-right: 1%;
}
/* 登録部分のレイアウト */
.registration {
  width: 60%;
  text-align: center;
  margin: 100px 20%;
}
.registration h2 {
  font-size: var(--font-size-xxl);
  font-weight: var(--font-weight-regular);
}
.registration p {
  width: 80%;
  font-size: var(--font-size-md);
  line-height: 2rem;
  margin-left: 10%;
  margin-right: 10%;
}
.registration a {
  font-size: var(--font-size-md);
  margin-top: 2rem;
}
.registration .login-button {
  background: #424041;
  color: var(--color-text-on-fixed-bg);
}

/* 日本語以外のレイアウト */
.top-contents:not(.ja) {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.catchcopy-line:not(.ja) {
  writing-mode: horizontal-tb;
  margin: 0;
  letter-spacing: normal;
}
.catchcopy-line2:not(.ja) {
  margin-right: 5%;
  padding-left: 0;
}
.top-message-description:not(.ja) {
  margin-top: 0;
}
.vision-contents:not(.ja) {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.vision:not(.ja) {
  writing-mode: horizontal-tb;
  margin: 0;
  letter-spacing: normal;
}
.vision-line2:not(.ja) {
  margin-right: 5%;
  padding-left: 0;
}

@media only screen and (max-width: 750px) {
  .header {
    padding: 1rem 1rem;
  }
  .header-logo {
    width: 100px;
  }
  .sign-up-button {
    padding: 5px 20px;
  }
  .login-button {
    padding: 5px 20px;
  }
  /* TOPコンテンツのレイアウト */
  .top-contents {
    height: 80vh;
  }
  .catchcopy-line {
    font-size: var(--font-size-lg);
    line-height: 24px;
    padding: 0.5rem;
  }
  .top-contents .sign-up-button {
    font-size: var(--font-size-sm);
  }
  .top-message {
    padding-top: 30px;
    padding-bottom: 30px;
  }
  .top-message-title {
    font-size: var(--font-size-xl);
  }
  .top-message-content {
    font-size: var(--font-size-md);
    padding: 0 1rem;
    text-align: left;
  }
  .top-message-description {
    margin-top: 0;
  }
  /* 画面説明のレイアウト */
  .row {
    display: inline-block;
    padding: 30px 0 0 0;
  }
  .col-lg-9-l {
    display: inline-block;
    width: 100%;
    padding: 0px;
  }
  .col-lg-9-r {
    width: 100%;
    padding: 0px;
  }
  .col-lg-3-r {
    display: inline-block;
    width: 100%;
    padding: 0px;
  }
  .col-lg-3-l {
    width: 100%;
    padding: 0px;
  }
  .service-img {
    width: 90%;
    margin: 10% 5% 0% 5%;
  }
  .service-txt {
    padding: 5% 1rem;
    padding-bottom: 10%;
  }
  .main-logo {
    display: block;
    width: 50%;
    padding: 15px 25%;
  }
  .screenshot-txt {
    padding: 5% 1rem;
  }
  .screenshot-txt h2 {
    font-size: var(--font-size-xl);
    text-align: center;
  }
  .screenshot-txt h3 {
    font-size: var(--font-size-md);
    text-align: center;
  }
  .screenshot {
    width: 60%;
    padding: 0 20%;
    box-shadow: 0 0 0px gray;
  }
  /* 2つ目のキャッチコピー画像のレイアウト */
  .vision-contents {
    height: 50vh;
    margin-top: 30px;
    background-position: 40% 0%;
  }
  .vision {
    font-size: var(--font-size-lg);
    line-height: 24px;
    padding: 0.5rem;
  }
  /* 登録部分のレイアウト */
  .registration {
    width: 100%;
    margin: 40px 0px;
  }
  .registration h2 {
    font-size: var(--font-size-xl);
  }
  .registration p {
    font-size: var(--font-size-sm);
    margin-bottom: 20px;
    margin-left: 1rem;
    margin-right: 1rem;
    text-align: left;
    width: calc(100% - 2rem);
  }

  /* 日本語以外のレイアウト */
  .top-contents:not(.ja) {
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }
  .catchcopy-line:not(.ja) {
    margin-left: 5%;
  }
  .catchcopy-line2:not(.ja) {
    margin-top: 4px;
    padding-left: 0.5rem;
  }
  .vision-contents:not(.ja) {
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
  }
  .vision:not(.ja) {
    margin-left: 5%;
  }
  .vision-line2:not(.ja) {
    margin-top: 4px;
    padding-left: 0.5rem;
    margin-bottom: 5%;
  }
}
</style>
